import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './ProgramacionPublicada.css'
import classNames from 'classnames/bind'
let cx = classNames.bind(css)

export class RowPublicadoCompleto extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
    }
    render() {
        let inv = this.props.inventario
        let labelNominas = ['label-default', 'label-default', 'label-default', 'label-success', 'label-info', 'label-primary']
        let estadoNominas = ['-', 'Deshabilitada', 'Pendiente', 'Recibida', 'Aprobada', 'Informada']
        let estadoConteo = ['SC', 'PE', 'PR', 'OP', 'SD', 'SO']
        let labelConteo = ['label-default', 'label-danger', 'label-warning', 'label-success', 'label-info', 'label-primary']
        return (
            <tr key={this.props.index}>
                {/* Correlativo */}
                <td className={css.tdIndex}>{this.props.correlativo}</td>
                <td className={css.tdFechaProgramada}>
                    <TextoconTooltip
                        visible={true}
                        value={inv.inv_fechaProgramadaC}
                        valorPadre={inv.inv_fechaProgramadaPadre}
                    />    
                </td>
                <td className={css.tdCliente}>{inv.cliente_nombreCorto}</td>
                <td className={css.tdCeco}>{inv.local_ceco}</td>
                <td className={css.tdRegion}>{inv.local_region}</td>
                <td className={css.tdComuna}>{inv.local_comuna}</td>
                <td className={css.tdLocal}>{inv.local_nombre}</td>
                <td className={css.tdDireccion}>
                    <p className={css.tooltip}>
                        <span className={"glyphicon glyphicon-search"}></span>
                        <span className={css.tooltiptext}>
                            {inv.local_direccion}
                        </span>
                    </p>
                </td>
                <td className={css.tdStock}>{inv.inv_stockTeorico.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                <td className={css.tdDotacion}>
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoDia}
                        value={inv.ndia_dotOperadores}
                        valorPadre={inv.ndia_dotOperadoresPadre}
                    />
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoNoche}
                        value={inv.nnoche_dotOperadores}
                        valorPadre={inv.nnoche_dotOperadoresPadre}
                    />
                </td>
                <td className={css.tdTurno}>{inv.inv_jornada}</td>
                <td className={css.tdLider}>
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoDia}
                        value={inv.ndia_lider}
                        valorPadre={inv.ndia_liderPadre}
                    />
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoNoche}
                        value={inv.nnoche_lider}
                        valorPadre={inv.nnoche_liderPadre}
                    />
                </td>
                <td className={css.tdLider}>
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoDia}
                        value={inv.ndia_supervisor}
                        valorPadre={inv.ndia_supervisorPadre}
                    />
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoNoche}
                        value={inv.nnoche_supervisor}
                        valorPadre={inv.nnoche_supervisorPadre}
                    />
                </td>
                <td className={css.tdHora}>
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoDia}
                        value={inv.ndia_hrLider}
                        valorPadre={inv.ndia_hrLiderPadre}
                    />
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoNoche}
                        value={inv.nnoche_hrLider}
                        valorPadre={inv.nnoche_hrLiderPadre}
                    />
                </td>
                <td className={css.tdHora}>
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoDia}
                        value={inv.ndia_hrEquipo}
                        valorPadre={inv.ndia_hrEquipoPadre}
                    />
                    <TextoconTooltip
                        visible={inv.inv_tieneTurnoNoche}
                        value={inv.nnoche_hrEquipo}
                        valorPadre={inv.nnoche_hrEquipoPadre}
                    />
                </td>                
                <td className={css.tdNomina}>
                    <BotonNomina
                        visible={inv.inv_tieneTurnoDia}
                        idNomina = {inv.ndia_idNomina}
                        label = {labelNominas[inv.ndia_idEstadoNomina]}
                        texto = {estadoNominas[inv.ndia_idEstadoNomina]}
                    />
                    <BotonNomina
                        visible={inv.inv_tieneTurnoNoche}
                        idNomina = {inv.nnoche_idNomina}
                        label = {labelNominas[inv.nnoche_idEstadoNomina]}
                        texto = {estadoNominas[inv.nnoche_idEstadoNomina]}
                    />
                </td>
                <td className={css.tdNomina}>
                    <BotonEstadoNomina
                        visible={inv.inv_tieneTurnoDia}
                        label = {labelConteo[inv.ndia_calificacionNomina]}
                        texto = {estadoConteo[inv.ndia_calificacionNomina]}
                        mensaje = {inv.ndia_mensaje}
                        stockSugerido = {inv.ndia_stockSugerido}
                        stockTeorico = {inv.inv_stockTeorico}
                        conteoSugerido = {inv.ndia_conteoSugerido}
                        totalTitulares = {inv.ndia_totalTitulares}
                        totalAgregados = {inv.ndia_dotOperadores}

                    />
                    <BotonEstadoNomina
                        visible={inv.inv_tieneTurnoNoche}
                        label = {labelConteo[inv.nnoche_calificacionNomina]}
                        texto = {estadoConteo[inv.nnoche_calificacionNomina]}
                        mensaje = {inv.nnoche_mensaje}
                        stockSugerido = {inv.nnoche_stockSugerido}
                        stockTeorico = {inv.inv_stockTeorico}
                        conteoSugerido = {inv.nnoche_conteoSugerido}
                        totalTitulares = {inv.nnoche_totalTitulares}
                        totalAgregados = {inv.nnoche_dotOperadores}
                    />
                </td>
            </tr>
        )
    }
}
RowPublicadoCompleto.contextTypes = {
}
const BotonNomina = ({visible, idNomina, label, texto})=>
    <div>
        <a href={`/nomina/${idNomina}`}
           className={cx('label',label, visible? 'center-block' : 'hide')}
           target="_blank">
            {texto}
        </a>
    </div>
const BotonEstadoNomina = ({visible, label, texto, mensaje, stockSugerido, stockTeorico, conteoSugerido, totalTitulares, totalAgregados})=>

    <div>
        <p className={css.tooltip}>
            <a
                className={cx('label',label, visible? 'center-block' : 'hide')}
                target="_blank">
                {texto}
            </a>
            <span className={css.tooltiptext}>
                -{mensaje}.<br/>
                -Stock Promedio Local: {stockSugerido}<br/>
                -Stock Informado: {stockTeorico}<br/>
                -Conteo Sugerido: {conteoSugerido}<br/>
                -Operadores: {totalTitulares+' de '+totalAgregados}
            </span>
        </p>
    </div>
const Texto = ({visible, value})=>
    <div className={visible?'':'hidden'}>
        {value}
    </div>
const TextoconTooltip = ({visible, value, valorPadre})=>
    <div className={visible?'':'hidden'}>
        {valorPadre?
            <div className={css.tdFechaEnMovimiento}>
                <p className={css.tooltip}>
                    {value}
                    <span className={css.tooltiptext}>
                        {`IG Semanal: ${valorPadre}`}
                    </span>
                </p>
            </div>
            :
            <div className={css.tdFecha}>
                {value}
            </div>
        }
    </div>
const Dotacion = ({visible, className, value})=>
    <div className={visible?'':'hidden'}>
        <p className={className}>
            {value}
        </p>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/inventarios/RowPublicado.jsx